import { render, staticRenderFns } from "./TableStrategies.vue?vue&type=template&id=8aa83dd8&scoped=true&"
import script from "./TableStrategies.vue?vue&type=script&lang=js&"
export * from "./TableStrategies.vue?vue&type=script&lang=js&"
import style0 from "./TableStrategies.vue?vue&type=style&index=0&id=8aa83dd8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa83dd8",
  null
  
)

export default component.exports